import { FETCH_CUPS, SELECT_CUPS } from "../constants/action-types";

export function fetchCups(payload) {
  return { type: FETCH_CUPS, payload };
}

export function selectCups(payload) {
  return { type: SELECT_CUPS, payload };
}